import { api } from "./api";

const endpoint = "volontariat/DomaineType";
const key = "AX009XWKLMO450SHJEKAZEI";
export const DomaineParAMIService = {
  async lister(filtre) {
    try {
      const result = await api.get(endpoint + "/liste", {
        params: { filtre: {...filtre, k : key} },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async insert(data) {
    try {
      const result = await api.post(endpoint + "/insert_or_delete", {...data, k : key});
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async update(data) {
    try {
      const result = await api.put(endpoint + "/update", {...data, k : key});
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async delete(filtre) {
    try {
      const result = await api.post(endpoint + "/delete", {...filtre, k : key});
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
  async find_one(filtre) {
    try {
      const result = await api.get(endpoint + "/find_one", {
        params: { filtre: filtre, k : key },
      });
      if (result) {
        return result.data;
      }
    } catch (error) {
      if (error.response) {
        return error.response.data;
      }
    }
  },
};
